import { CellProps } from 'react-table'
import { GrupoList } from '../../core/_models'
import { GruposActionsCell } from './GruposActionsCell'
import { TFunction } from '_metronic/i18n/Metronici18n'
import { PlainHeader, StackedCell, TableColumn } from 'app/components'

// Lista sem paginação e já ordenada por nome (ver filtrarGrupos): cabeçalhos não ordenáveis.
export const GruposColumns = (t: TFunction): ReadonlyArray<TableColumn<GrupoList>> => [
  {
    Header: () => <PlainHeader>{t('nome.label')}</PlainHeader>,
    id: 'nome',
    Cell: ({ row }: CellProps<GrupoList>) => (
      <StackedCell primary={row.original.nome} secondary={row.original.descricao} />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<GrupoList>) => <GruposActionsCell grupo={row.original} />,
  },
]
